import { useState } from "react";
import { Outlet } from "react-router-dom";
import { AdminSidebar } from "./AdminSidebar";
import { AdminHeader } from "./AdminHeader";

export const AdminLayout = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false); // Default to expanded

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <div className="min-h-screen bg-background flex flex-col w-full">
      <AdminHeader onToggleSidebar={toggleSidebar} />
      
      <div className="flex flex-1 w-full">
        <AdminSidebar isCollapsed={isSidebarCollapsed} />
        
        <main className="flex-1 transition-all duration-300 p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};